<div class="mt-3 bg-light p-3">
    <h2>Инлайн инпут (app-component-input-inline)</h2>
    <p>
        Есть 2 режима работы - через карандаш и постоянно активный <br>
        Также жирный и обычный текст
    </p>
    <div class="btn-group mb-2">
        <button (click)="editByPen = !editByPen"
                class="btn btn-primary"
        >
            Изменить режим
        </button>
        <button (click)="bold = !bold"
                class="btn btn-primary"
        >
            Изменить стиль текста
        </button>
    </div>
    <div>
        <app-component-input-inline
                [bold]="bold"
                [editByPen]="editByPen"
                [value]="'Текст для редактирования'"
        ></app-component-input-inline>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Редактор описания (app-component-ckeditor)</h2>

    <p>
        Есть 2 режима работы - с постоянными кнопками и event сохранения по завершении редактирования<br>
        Компонент принимает как string, так и HTML разметку (сам по себе работает с разметкой, string он оборачивает в
        тег &lt;p&gt;<br>
        В emitFinish возвращает введенный текст как HTML разметку
    </p>

    <div class="btn-group mb-2">
        <button (click)="isShowButtons = !isShowButtons"
                class="btn btn-primary"
        >
            Изменить режим
        </button>
    </div>

    <div>
        <app-component-ckeditor
                [inputData]="'Тут текст редактора'"
                [isEnable]="false"
                [isShowButtons]="isShowButtons"
        ></app-component-ckeditor>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Поиск документов (app-component-documents-search)</h2>

    <p>
        Поиск документов, <strong>находится в шапке этой страницы</strong>
    </p>

    <div class="header-custom">
        <app-header-page>
            <app-component-documents-search></app-component-documents-search>
        </app-header-page>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Кнопка дропдаун (app-component-button-more)</h2>

    <p>
        Есть 2 режима - скрытый (иконка 3 точки) и полный (с текстом) <br>
        Также жирный и обычный стиль текста
    </p>

    <div class="btn-group mb-2">
        <button (click)="hiddenMore = !hiddenMore"
                class="btn btn-primary"
        >
            Изменить режим
        </button>
        <button (click)="boldMore = !boldMore"
                class="btn btn-primary"
        >
            Изменить стиль текста
        </button>
    </div>

    <div>
        <app-component-button-more
                [bold]="boldMore"
                [hidden]="hiddenMore"
                [variables]="[
                                    {key: 'NEW', icon: 'icon-up-16px', title: 'Новое' | translate, color: '#3CD33C'},
                                    {key: 'IN_PROGRESS', icon: 'icon-up', title: 'В процессе' | translate, color: '#d9c72b'},
                                    {key: 'EXECUTED', icon: 'icon-up-1', title: 'Исполнено' | translate, color: '#E62E49'},
                                    {key: 'IN_ARCHIVE', icon: 'icon-up-1', title: 'Архив' | translate, color: '#ee94a1'}
                                ]"
                position="left"
        >
            <p>
                Текст:
                <span style="cursor: pointer;"> значение </span>
            </p>
        </app-component-button-more>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Пагинация (app-component-pagination)</h2>

    <div>
        <app-component-pagination
                [pagination]="{
                    current_page: 5,
                    limit: 50,
                    pages: 20,
                }"
        ></app-component-pagination>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Алерт (app-component-alert)</h2>

    <div class="btn-group mb-2"
         role="group">
        <button (click)="alert.setAlert('Success text', 'green')"
                class="btn btn-primary">Зеленый алерт (успешный)
        </button>
        <button (click)="alert.setAlert('Error text', 'blue')"
                class="btn btn-primary">Синий алерт (ошибка)
        </button>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Календарь (app-component-date-time-picker)</h2>
    <p>
        Есть 2 режима работы - с часами и без<br>
        Есть инлайн календарь (показывается пустой инпут, по клику вызывается календарь) <br>
        И скрытие календаря, если он нужен не всегда, то по дефолту он скрыт, вызывается эмулированием клика по
        компоненту
    </p>
    <div class="btn-group mb-2">
        <button (click)="hiddenCalendar = !inlineCalendar"
                class="btn btn-primary"
        >
            Инлайн календарь
        </button>
        <button (click)="hiddenCalendar = !hiddenCalendar"
                class="btn btn-primary"
        >
            Скрыть календарь
        </button>
        <button (click)="showTime = !showTime"
                class="btn btn-primary"
        >
            Показать время
        </button>


        <button (click)="calendar.click()"
                class="btn btn-primary"
        >
            Вызвать календарь
        </button>
    </div>

    <div>
        <app-component-date-time-picker
            #calendar
            [hiddenCalendar]="hiddenCalendar"
            [inline]="inlineCalendar"
            [showTime]="showTime"
        ></app-component-date-time-picker>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Загрузка (app-component-loading)</h2>

    <div>
        <strong>Тип 1</strong>
        <br>
        <app-component-loading></app-component-loading>

        <br>

        <strong>Тип 2</strong>
        <app-component-loading [size]="'inline'"></app-component-loading>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Выбор цвета (app-color-picker)</h2>

    <p>Поддерживает текст, если не указывать базовый цвет, то блок прозрачен</p>

    <div class="w-25">
        <app-color-picker
                [name]="'Текст указан'"
        ></app-color-picker>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Аватар профиля (app-avatar)</h2>

    <p>Аватары пользователей (пока без поддержки картинок), цвета выбираются через контрольную сумму по email
        пользователя из заданного
        внутри массива, буквы на фоне - фамилия и имя, если они не указаны, то буква почты</p>

    <div style="height: 70px;">
        <app-avatar
                [size]="'mini'"
                [profile]="member"
        ></app-avatar>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Числовой селект (app-select)</h2>

    <p>
        Принимает как массив чисел, так и промежуток в формате [ ОТ, ДО ], <br>
        Имеется поиск и подсветка выбранного значения, если есть
    </p>

    <div>
        <app-select [data]="[1, 40]"
                    [needConvert]="true"
                    [selected]="2"
        ></app-select>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Аккордеон (app-accordion)</h2>

    <p>
        Принимает объект формата
    </p>
    <strong>
        <pre [innerHTML]="jsonDataToDisplay"></pre>
    </strong>
    <p>
        Где:<br>
        <strong>headerText</strong> - Название в шапке аккордеона <br>
        <strong>id</strong> - обязательный параметр для работы аккордеона <br>
        <strong>dataForTemplate</strong> - Объект, с которым идет работа в персональном темплейте, который инжектится в
        тело аккордеона <br>
        <strong>editHeaderText</strong> - флаг, включающий редактирование шапки аккордеона <br>
        <strong>templateAccordionBody</strong> - персональный темплейт, который инжектится в тело аккордеона.
        Указывается один раз, множится
        на все аккордеоны
    </p>
    <div>
        <app-accordion
                [accordionData]="{
					                allHeaders: [
					                    {
                                            headerText: 'Аккордион 1',
                                            id: 'a1',
                                            dataForTemplate: { text: 'Тут текст 1' },
                                            editHeaderText: true,
					                    },
					                    {
                                            headerText: 'Аккордион 2',
                                            id: 'a2',
                                            dataForTemplate: { text: 'Тут текст 2' },
                                            editHeaderText: false,
					                    },
					                ],
					                templateAccordionBody: accordionTemplate
				                }"
        ></app-accordion>

        <ng-template #accordionTemplate
                     let-data="data"
        >
            {{ data.text }}
        </ng-template>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Аккордеон с таблицей бизнес-процесса для детальной карточки пользователя (app-boards-accordion)</h2>

    <p>
        Принимает только модель пользователя, отличие от основного аккордеона только в том, что у него своя шапка с
        кнопками и только
        один темплейт с одной логикой. (не выведен отдельно из-за кастомной шапки)
    </p>

    <div class="input-group mb-3 w-25">
        <input #guidFirst
               aria-describedby="button-addon2"
               class="form-control"
               placeholder="GUID пользователя"
               type="text">
        <button (click)="customMember.guid = guidFirst.value"
                class="btn btn-outline-secondary"
                id="button-addon2"
                type="button">Применить
        </button>
    </div>

    <div *ngIf="customMember.guid">
        <app-boards-accordion [profile]="member"></app-boards-accordion>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Файловая структура для детальной карточки пользователя (app-documents-repo-structure)</h2>

    <p>
        Принимает только модель пользователя, работа с документами, доступными пользователю
    </p>
    <div class="input-group mb-3 w-25">
        <input #guidSecond
               [value]="customMember.guid"
               aria-describedby="button-addon2"
               class="form-control"
               placeholder="GUID пользователя"
               type="text">
        <button (click)="customMember.guid = guidSecond.value"
                class="btn btn-outline-secondary"
                id="button-addon2"
                type="button">Применить
        </button>
    </div>

    <div *ngIf="customMember.guid">
        <app-documents-repo-structure [profile]="member"></app-documents-repo-structure>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Поручения пользователя (app-all-assignments)</h2>

    <p>
        Компонент с поручениями
    </p>

    <div>
        <app-all-assignments
                [headerVisible]="false"
        ></app-all-assignments>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Поручение детально (app-detail-assignments)</h2>

    <p>
        Для открытия необходимо в таблице выше кликнуть на поручение
    </p>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Таблица документов (app-component-folder-and-file-table)</h2>

    <p>
        Есть 2 режима отображения - большой и маленький<br>
        Также можно убрать кнопку "назад"<br>
    </p>

    <div class="btn-group mb-2">
        <button (click)="changeSizeFileTable()"
                class="btn btn-primary"
        >
            Изменить режим
        </button>
        <button (click)="showBackButton = !showBackButton"
                class="btn btn-primary"
        >
            Кнопка назад
        </button>
    </div>

    <div>
        <app-component-folder-and-file-table
                [$mediator]="controller.$mediator"
                [isSelected]="true"
                [showBackButton]="showBackButton"
                [view]="isMini"
        ></app-component-folder-and-file-table>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Файловый навигатор (app-component-file-navigator)</h2>

    <p>
        ЕИспользуется для выбора документа в модалках
    </p>

    <div>
        <app-component-file-navigator></app-component-file-navigator>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Таблица задач (app-component-tasks-table)</h2>

    <p>
        Таблица с задачами, есть уменьшенный вид (только ограничивает высоту компонента для модалки)
    </p>

    <div class="btn-group mb-2">
        <button (click)="minimizedTaskTable = !minimizedTaskTable"
                class="btn btn-primary"
        >
            Уменьшенная таблица
        </button>
    </div>

    <div>
        <app-component-tasks-table
                [isMini]="minimizedTaskTable"
                [personGuid]="member.guid"
        ></app-component-tasks-table>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Задача детально (app-component-task-detail)</h2>

    <p>
        Внутри есть 2 вида отображения через кнопку сверху слева.
    </p>

    <div class="input-group mb-3 w-25">
        <input #taskAlias
               aria-describedby="button-addon2"
               class="form-control"
               placeholder="Alias задачи (без #)"
               type="text">
        <button (click)="taskAliasValue = taskAlias.value"
                class="btn btn-outline-secondary"
                id="button-addon2"
                type="button"
        >
            Применить
        </button>
    </div>

    <div *ngIf="taskAliasValue">
        <app-component-task-detail
                [taskAlias]="taskAliasValue"
        ></app-component-task-detail>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Модалка платежки (app-payment-modal)</h2>

    <p>
        Внутри есть 2 вида отображения, детальное (полное) и минимизированное.
    </p>

    <div class="input-group mb-3 w-50">
        <button (click)="detailPaymentView = !detailPaymentView; paymentGuidValue = ''"
                class="btn btn-primary"
        >
            Переключить вид (необходимо снова ввести GUID)
        </button>
        <input #paymentGuid
               aria-describedby="button-addon2"
               class="form-control"
               placeholder="GUID платежа"
               type="text">
        <button (click)="paymentGuidValue = paymentGuid.value"
                class="btn btn-outline-secondary"
                id="button-addon2"
                type="button"
        >
            Применить
        </button>
    </div>

    <div *ngIf="!detailPaymentView || paymentGuidValue">
        <app-payment-modal
                [detail]="detailPaymentView"
                [paymentGuid]="paymentGuidValue"
                [payments]="payments"
        ></app-payment-modal>
    </div>
</div>


<div class="mt-3 bg-light p-3">
    <h2>Колоночное отображение задач (app-task-column)</h2>

    <p>
        Вид отображение задач в виде колонок статусов
    </p>

    <div class="input-group mb-3 w-25">
        <input #boardAlias
               aria-describedby="button-addon2"
               class="form-control"
               placeholder="Alias бизнес-процесса"
               type="text">
        <button (click)="boardAliasValue = boardAlias.value"
                class="btn btn-outline-secondary"
                id="button-addon2"
                type="button"
        >
            Применить
        </button>
    </div>

    <div *ngIf="boardAliasValue">
        <app-task-column
                [alias]="boardAliasValue"
        ></app-task-column>
    </div>
</div>


<div class="mt-3 bg-light p-3">
    <h2>Компонент отображение групп и бизнес-процессов (app-task-dashboards)</h2>

    <p>
        Не имеет внутри альтернативного вида
    </p>

    <div>
        <app-task-dashboards *ngIf="boards"
                             [boardGroups]="boardGroups"
                             [boards]="boards"
                             [headerVisible]="false"
        ></app-task-dashboards>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Детальный просмотр документа (app-component-doc-view)</h2>

    <div class="input-group mb-3 w-25">
        <input #key
               aria-describedby="button-addon2"
               class="form-control"
               placeholder="Key документа"
               type="text">
        <button (click)="documentKey = key.value"
                class="btn btn-outline-secondary"
                id="button-addon2"
                type="button"
        >
            Применить
        </button>
    </div>

    <div *ngIf="documentKey">
        <app-component-doc-view
                [fileUkey]="documentKey"
        ></app-component-doc-view>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Комментарии задачи (app-task-detail-comments)</h2>

    <p>Также используются в поручениях</p>

    <div class="input-group mb-3 w-25">
        <input #taskAliasComments
               aria-describedby="button-addon2"
               class="form-control"
               placeholder="Task alias задачи"
               type="text">
        <button (click)="getTask(taskAliasComments.value)"
                class="btn btn-outline-secondary"
                id="button-addon2"
                type="button"
        >
            Применить
        </button>
    </div>

    <div *ngIf="taskData">
        <app-task-detail-comments
                [taskData]="taskData"
        ></app-task-detail-comments>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Логи задачи (app-task-detail-logs)</h2>

    <div class="input-group mb-3 w-25">
        <input #taskAliasLogs
               aria-describedby="button-addon2"
               class="form-control"
               placeholder="Task alias задачи"
               type="text">
        <button (click)="taskAliasLogsValue = taskAliasLogs.value"
                class="btn btn-outline-secondary"
                id="button-addon2"
                type="button"
        >
            Применить
        </button>
    </div>

    <div *ngIf="taskAliasLogsValue">
        <app-task-detail-logs
                [taskAlias]="taskAliasLogsValue"
        ></app-task-detail-logs>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Настройки пользовательских полей файлов (app-file-options)</h2>

    <div>
        <app-file-options
                [visibleHeader]="false"
        ></app-file-options>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Настройки меню (app-sidebar-settings)</h2>

    <div>
        <app-sidebar-settings
                [visibleHeader]="false"
        ></app-sidebar-settings>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Детальные пользовательские поля (app-detail-property)</h2>

    <div class="d-flex">
        <div class="w-25">
            <span>canEdit = true</span>
            <app-detail-property
                    [customProperties]="customProperties"
                    [target]="'board'"
            ></app-detail-property>
        </div>
        <div class="w-25">
            <span>canEdit = false</span>
            <app-detail-property
                    [canEdit]="false"
                    [customProperties]="customProperties"
                    [target]="'board'"
            ></app-detail-property>
        </div>
    </div>
</div>

<div class="mt-3 bg-light p-3">
    <h2>Комментарии задачи (app-task-detail-comments)</h2>

    <p>Также используются в поручениях</p>

    <div class="input-group mb-3 w-25">
        <input #visorsFileKey
               aria-describedby="button-addon2"
               class="form-control"
               placeholder="Task alias задачи"
               type="text">
        <button (click)="visorsFileKeyValue = visorsFileKey.value"
                class="btn btn-outline-secondary"
                id="button-addon2"
                type="button"
        >
            Применить
        </button>
    </div>

    <div *ngIf="visorsFileKeyValue" class="w-25">
        <app-visors
                [fileKey]="visorsFileKeyValue"
        ></app-visors>
    </div>
</div>
